/* eslint-disable */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable no-loop-func */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable quote-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import axios from 'axios';
import Tour from 'reactour';
import { Redirect } from 'react-router';
import Popup from 'reactjs-popup';
import Actions      from './../../components/Actions/Actions';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import QuickActionModal from '../../components/Modals/QuickActionModal/QuickActionModal';
import Classes from './CastScreen.css';
import Aux from '../../hoc/Aux';
import OnlineSongManager from '../../components/OnlineSongManager/OnlineSongManager';
import socket from '../../SocketManager';
import NextSong from '../../components/NextSong/NextSong';
import MConfig from '../../moramma-config.json';
import logger from '../../logger';
import helpers from '../../helpers/helpers';
import MenuPlaylistItem from '../../components/MenuPlaylistItem/MenuPlaylistItem';
import lang from '../../lang.json';
import DeezerPlayer from '../../components/OnlineSongManager/DeezerPlayer';

import OnlineSongCast   from './../../components/OnlineSongCast/OnlineSongCast';

class CastScreen extends Component {
    state = {
        socket: {
            signature: 'nextsong-signature'
          },
        token: '',
        roomName: '',
        songs : [],
        actions : [],
        logged: false,
        onlineSong: null,
        language: 'IT-it'
    }

    componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const token = query.get('token');

      if(token) {
        this.setState({token: token});
      }

    }

    handleInputEvent = (event) => {
      if (event.target.value.includes('https://')) {
        const val = event.target.value.split('=')[1];
        console.log('val', val);
        this.setState({
          token: val
        })
      }
      else {
        this.setState({
          token: event.target.value
        })
      }
      
    }

    connectToSpot = () => {
        this.startSocketEvents(this.state.roomName);
    }

    startSocketEvents = (room) => {
        socket.on('connect', () => {
        });    


        logger.debug(`[NEXTSONG][componentDidMount() | connect] send signature '${this.state.socket.signature}'to server for validation`);
        socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: room});

        /** wait ack */
        // TODO: repace with jwt
        socket.on('server-ack-id-validation', () => {
            logger.debug('[NEXTSONG][componentDidMount() | server-ack-id-validation] receive ack validation from server');
        });

        /** DEPRECATED */
        socket.on('server-new-song', ( data ) => {                
            logger.debug('[NEXTSONG][componentDidMount() | server-new-song] receive new json');
           // console.log('ooo', data);
            this.onNewSongHandler(data);
        });

        
        /** SOCKET: [r-server-vote-song] */
        socket.on('r-server-vote-song', ( data ) => {
            logger.debug('[NEXTSONG][componentDidMount() | r-server-vote-song] receive new action');

            
            this.onNewActionHandler(data);                
        });

        socket.on('r-server-song-go-online', ( data ) => {
            logger.debug('[NEXTSONG][componentDidMount() | r-server-song-go-online] receive new action and song');

            let action = data.action;
            let song = data.songs;

            this.onNewActionHandler(action);
            
            this.onNewSongHandler(song);

            this.setState({ eventForTriggerMinSongTimerToOnlineSongComponent: !this.state.eventForTriggerMinSongTimerToOnlineSongComponent });
        });

        socket.on('r-server-skip-action', ( payload ) => {
            logger.debug(`[NEXTSONG][componentDidMount() | r-server-skip-action] receive new skip action`+ JSON.stringify(payload));

            this.onNewActionHandler(payload);
        });

        /**
         * Received new song
         */
        socket.on('r-server-new-song', ( data ) => {
            logger.debug(`[ManagerScreen|r-server-new-song] SOCKET.IO -server-new-song`);
            logger.debug(`[ManagerScreen|r-server-new-song] Received new song`);
            this.onNewSongVotedHandler(data);                
        });

        socket.on('connect_error',() => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] connect_error`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });  

         /**
          * Fired upon a connection timeout.
          */
         socket.on('connect_timeout', (timeout) => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] connect_timeout`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });
 
         /**
          * Fired when an error occurs.
          */
         socket.on('error', (error) => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] error`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });
 
         socket.on('disconnect', (reason) => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] disconnect`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });

         /**
          * Fired when couldn’t reconnect within reconnectionAttempts.
          */
         socket.on('reconnect_failed', () => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] reconnect_failed`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });

         socket.on('server-owner-data-updated', (payload) => {
            logger.debug('[ManagerScreen][componentDidMount() | server-owner-data-updated] receive new userdata changes', payload);
    
            let oldLang = this.state.language;
            oldLang = payload.owner.language;
            this.setState({ language: oldLang });
          });

          /**
         * All songs has been deleted, refresh it
         */
        socket.on('server-delete-all-songs', (data) => {
            logger.debug('[ManagerScreen|server-delete-all-songs] Called');
            this.onSongsDeleted(data);                
        });

        /**
         * song is deleted
         */
        socket.on('r-server-delete-song', (data) => {
            logger.debug('[ManagerScreen|r-server-delete-song] Called');
            this.onSongDeletedSetState(data.song);     
            // this.onNewActionHandler(data);           
        });
    }

    onSongsDeleted = (data) => {
      let oldSongs = this.state.songs;
      oldSongs = oldSongs.filter((el) => el.type === 'onlineSong');

      this.setState({ songs: oldSongs });
    }

    onSongDeletedSetState = (song) => {
      let oldSongs = this.state.songs;
      oldSongs = oldSongs.filter((el) => el.id !== song.id);

      this.setState({ songs: oldSongs });
    }

    onNewActionHandler = (data) => {
      let oldactions = this.state.actions;

      oldactions = [data].concat(oldactions);

      if(oldactions.length >= 7) {
          oldactions.pop();
      }

      this.setState({actions : oldactions});
  };

  onNewSongVotedHandler = (data) => {
    let oldSongs = this.state.songs;

    // search song inside this.state
    const found = oldSongs.findIndex( el => { 
        return el._id === data._id;
    });

    if (found < 0) {
        // if song is new, add
        oldSongs = oldSongs.concat(data);
    }
    else {
        // replace with new data
        oldSongs.splice(found, 1);
        oldSongs = oldSongs.concat(data);
    }

    oldSongs.sort(this.compare);

    // set state
    this.setState({songs : oldSongs});
};

      onNewSongHandler = (data) => {
        if(Array.isArray(data)) {
            data.forEach((el) => {
                if (el.type === 'songVoted') {
                  let oldSongs = this.state.songs;
                  const index = oldSongs.findIndex(x => x.id === el.id);
                  if (index === -1) {
                    // adding song
                    oldSongs = oldSongs.concat(el);
                  } else {
                    // replace with new data
                    oldSongs.splice(index, 1);
                    oldSongs = oldSongs.concat(el);
                  }  
        
                  oldSongs.sort(helpers.compare);
                  this.setState({ songs: oldSongs });
                }
                else if(el.type === 'onAir') {
                    let oldSongs = this.state.songs;
                    const index = oldSongs.findIndex(x => x.id === el.id);

                    if(index !== -1) {
                        oldSongs.splice(index, 1);
                    }
                    // 
                    this.setState({onlineSong : el, songs : oldSongs});
                }
              });
        } else {
            if(data.type === 'songVoted'){
                const oldSongs = this.state.songs;
                const newSongs = oldSongs.concat(data)
            
                newSongs.sort(this.compare);
                this.setState({songs : newSongs});
            }  
            if(data.type === 'onAir') {
                const oldSongs = this.state.songs;
                oldSongs.shift(); 
                this.setState({onlineSong : data, songs : oldSongs});
            }
        } 
    }

    /** Compare function to order publiscreen list */
    compare = ( a, b ) => {
      const votesB = b.votes; 
      const votesA = a.votes;

      if (votesB < votesA) {
          return -1;
      }
      if (votesB > votesA) {
          return 1;
      }

      const insTimeA = a.insertionTime.toUpperCase();
      const insTimeB = b.insertionTime.toUpperCase();
      if (insTimeA < insTimeB) {
          return -1;
      }
      if (insTimeA > insTimeB) {
          return 1;
      }
      
      // names must be equal
      return 0;
  }

      loginEvent = async () => {
        console.log(this.state.token)
        await axios({
          method: 'post',
          url: `${MConfig.BASE_API}/react/cast/auth`,
          headers: {

            "Authorization" : `Bearer ${this.state.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          data: { authToken: this.state.token }
        }).then(items => {
          if(items.data.spotName) {
            this.setState({
              logged: true,
              roomName: items.data.spotName,
            })
            console.log('ok qua')
            this.connectToSpot();
            this.fetchActualSpotStatus(items.data.spotName, this.state.token);
          }
        }).catch(err => {
          ToastsStore.error('Link di invito non valido.')
          logger.error('[ManagerScreen|loginEvent] Error during  API/react/cast/auth ', err);
        });
      }

      fetchActualSpotStatus = async (room, localtoken) => {
       // console.log('rrr', this.state.roomName);
        console.log(room, localtoken)
        await axios({
            method: 'get',
            url: `${MConfig["BASE_API"]}/rooms/${room}/songs`,
            headers: {
                "Authorization" : `Bearer ${localtoken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
          }).then(items => {
            console.log('ddddddataaaa', items);
            this.onNewSongHandler(items.data.data);
          });  
    }


    render() {
      if(!this.state.logged) {
        return (
          <Aux>
            <div className="container-fluid">
              <br/>
              <br/>
              <div className="d-flex flex-column align-items-center">
                <h3>Benvenuto nella condivisione del Moramma spot!</h3>
                <p>Puoi accedere e ascoltare in tempo reale la condivisione delle canzoni riprodotte da uno spot.</p>
                <p>Hai un link d'invito per accedere? Incollalo qua sotto!</p>
                <br />
                <br />
                <div className={Classes.Link}>
                    <i class="fas fa-key"></i>
                    <input className={Classes.Link} onChange={this.handleInputEvent} value={this.state.token} />
                </div>
                {
                    this.state.token === '' ? (
                        ''
                    ) : (
                      <div>
                        <br />
                        <button className={`${Classes.LoginButton} animated fadeInUp`} onClick={this.loginEvent} type="button"> Entra </button>
                      </div> 
                    )
                }    
                <br/>
                <ReactTooltip/>
                <br />
                <p><i>Non hai un link d'invito? richiedilo al gestore dello spot!</i></p>
                <br />
              <br />
              <img src={require('../../assets/img/ic_cast.png')} className={Classes.MainImg} />
              </div>
            </div>
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />  
          </Aux>
        );
      } else {
        return (
          <Aux>
            <div className="container-fluid">
              <br/>
              <br/>
              <div className="d-flex flex-column align-items-center">
                <h3>Ciao, benvenuto nella condivisione dello spot: <span className={Classes.LinkSpot}> &nbsp; {this.state.roomName} &nbsp; </span></h3>
                <p><i>Assicurati di aver effettuato il login su <a target="_blank" href="https://deezer.com">deezer</a> per non avere il limite dei 30 secondi d'ascolto. Non senti la musica? visita le <a target="_blank" href="https://moramma.com/FAQ-it.html">FAQ</a></i></p>
                <p><i>Vuoi proporre una canzone o interagire con lo spot? Scarica l'applicazione "<strong>Moramma</strong>" dagli store <a href="https://itunes.apple.com/it/app/moramma/id1382717294?mt=8" target="_blank">iOS</a> e <a href="https://play.google.com/store/apps/details?id=wagooitalia.wagoomusic&hl=it" target="_blank">Android</a>!</i></p>
                <br />
                <br />
                {
                  this.state.onlineSong ? (
                    <DeezerPlayer
                      autoplay={true}
                      songid={this.state.onlineSong.id}/>
                  ) : (
                    ''
                  )
                }
              </div>
              <div className='row'>
                <div className="col" />

                <div className="col-6" >
              {
                  this.state.onlineSong ? (
                    <OnlineSongCast
                            song={this.state.onlineSong}
                            actions={this.state.actions}
                            songs={this.state.songs} 
                            startTimer={this.state.eventForTriggerMinSongTimerToOnlineSongComponent}
                            language={this.state.language}
                            roomName={this.state.roomName}
                        />
                  ) : (
                    ''
                  )
                }  
 </div>
              <div className="col" />
                <br />
                <hr />
                <br />
                </div>
              </div>
              <div className="container">
                <div className="row justify-content-center align-self-center">
                <br />
              <div className='col' />
              <div className='col-6'>
                    <NextSong
                      songs={this.state.songs} 
                      upcomingTitle={lang[this.state.language].upcoming_songs}
                    />
                </div>
                <div className='col' />
                <div className='col-5'>
                  <Actions                        
                    events={this.state.actions}
                    eventTitle={lang[this.state.language].events_title}
                    language={this.state.language}
                  />
                </div>
                <div className='col' />
              </div>
              </div>
            <br />
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />  
          </Aux>
        );
      }
    }
} 

export default CastScreen;
